const _ = require('lodash');
const axios = require('axios');

export default {
    _app : null,
    init() {
        this._app = document.querySelector('[data-vue-product-search]');
        if (!this._app) {
            return;
        }
        new Vue({
            el        : this._app,
            delimiters: ['[[', ']]'],
            data      : {
                loading       : true,
                display               : 'products',
                search                : '',
                map                   : null,
                bounds                : null,
                products              : [],
                mapData               : [],
                infoWindow            : [],
                activeInfoWindow      : null,
                pageIndex             : 0,
                productsPerPage       : 18,
                selectedCategories    : [],
                selectedMunicipalities: [],
                selectedSubCategories : [],
                amounts               : {},
                categories            : [],
                subCategories         : [],
                municipalities        : [],
                menuTags              : {},
            },
            created()
            {
                this.getQueryParamValues();
                this.getProducts();
                this.setFavorites();
            },
            methods: {
                setFavorites(event) {
                    // var currentID;
                    const favoritesObject = JSON.parse(localStorage.getItem('favorites'));

                    const allHeartElements = document.querySelectorAll('.heart');

                    for (let heartsIndex = 0; heartsIndex < allHeartElements.length; heartsIndex++) {
                        allHeartElements[heartsIndex].classList.remove("heart--active");
                    }

                    if (favoritesObject) {
                        for (let lsIndex = 0; lsIndex < favoritesObject.length; lsIndex++) {
                            for (let heartsIndex = 0; heartsIndex < allHeartElements.length; heartsIndex++) {
                                if (allHeartElements[heartsIndex] && allHeartElements[heartsIndex].id) {
                                    if ( favoritesObject[lsIndex] == allHeartElements[heartsIndex].id ) {
                                        allHeartElements[heartsIndex].classList.add("heart--active");
                                    }
                                }
                            }
                        }
                    }
                },

                toggleFavorites (event) {
                    // console.log(event.target);
                    event.preventDefault();
                    event.stopPropagation();

                    if (event.target.className == "heart heart--active") event.target.className = "heart";
                    else event.target.className = "heart heart--active";

                    var currentID = parseInt(event.target.id);
                    var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites'));

                    var header_favorites_icon = document.getElementById("header__favorites--icon");
                    if ( favoritesLocalStorageObject && favoritesLocalStorageObject.includes(currentID) ) {
                        for (var i = 0; i < favoritesLocalStorageObject.length; i++) {
                            if (favoritesLocalStorageObject[i]==currentID) favoritesLocalStorageObject.splice(i, 1);
                        }
                        if ( favoritesLocalStorageObject.length == 0 && header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                            header_favorites_icon.classList.remove("header__favorites--icon-active");
                        }
                    }
                    else if (favoritesLocalStorageObject) {
                        favoritesLocalStorageObject.push(currentID);
                        if ( favoritesLocalStorageObject.length > 0 && !header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                            header_favorites_icon.classList.add("header__favorites--icon-active");
                        }
                    }
                    else {
                        favoritesLocalStorageObject = [ currentID ];
                        if ( favoritesLocalStorageObject.length > 0 && !header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                            header_favorites_icon.classList.add("header__favorites--icon-active");
                        }
                    }

                    localStorage.setItem('favorites', JSON.stringify(favoritesLocalStorageObject) );
                    event.preventDefault();
                },
                getQueryParamValues() {
                    const params  = new URLSearchParams(window.location.search);
                    const search  = params.get('s');
                    this.search                 = search ? search.replace(/\s+/g,' ').trim() : '';
                    this.selectedCategories     = params.getAll('kategori[]');
                    this.selectedMunicipalities = params.getAll('kommune[]');
                },

                getProducts()
                {
                    axios.get('/actions/mm/poi/index')
                        .then(this.getProducts__callback)
                        .catch(function (error) { console.log(error)});
                },

                getProducts__callback(response)
                {
                    if (typeof response.data === 'object' && response.data !== null) {
                        this.products = response.data;
                        this.filterHandler();
                    }

                    this.loading = false;
                },

                // Filters - shared //
                searchFilter (items) {
                    this.setFavorites();
                    if (!this.search) {
                        return items;
                    }
                    return items.filter(item => {
                        // extended search
                        const titleMatch = item.title.match(new RegExp(this.search, 'gi'));
                        const teaserMatch = (item.teaser) ? item.teaser.match(new RegExp(this.search, 'gi')) : false;
                        const excerptMatch = (item.excerpt) ? item.excerpt.match(new RegExp(this.search, 'gi')) : false;
                        return titleMatch || teaserMatch || excerptMatch;
                    });
                },

                // Filters - products //
                categoryFilter(products)
                {
                    this.setFavorites();
                    if (!this.selectedCategories.length) {
                        return products;
                    }
                    return products.filter(product => {
                        return this.selectedCategories.includes(product.category);
                    });
                },
                subCategoryFilter(products)
                {
                    this.setFavorites();
                    if (!this.selectedSubCategories.length) {
                        return products;
                    }
                    return products.filter(product => {
                        return this.selectedSubCategories.includes(product.sub_category);
                    });
                },
                municipalitiesFilter: function(products)
                {
                    this.setFavorites();
                    if (!this.selectedMunicipalities.length) {
                        return products;
                    }
                    return products.filter(product => {
                        return this.selectedMunicipalities.includes(product.municipality);
                    });
                },
                filteredProducts: function(products)
                {
                    this.setFavorites();
                    let filteredProducts = this.searchFilter(products);
                        filteredProducts = this.categoryFilter(filteredProducts);
                        filteredProducts = this.subCategoryFilter(filteredProducts);
                        filteredProducts = this.municipalitiesFilter(filteredProducts);

                    return filteredProducts;
                },

                // General methods //
                goToPage(pageNumber) {
                    this.pageIndex = pageNumber;
                },
                displayPaginationNumber(number) {
                    if (this.pageIndex < 5 && number < 11) {
                        return true;
                    }

                    const length = this.paginatedResults.length;

                    if (Math.abs(length - this.pageIndex) < 5 &&
                        Math.abs(length - number) < 11) {
                        return true;
                    }

                    return Math.abs(this.pageIndex - number) < 6
                },

                // Handlers //
                filterHandler() {
                    setTimeout(() => {
                        const subCategories = new Set();
                        const categories = new Set();
                        const municipalities = new Set();

                        this.products.forEach((p) => {
                            if (p.category.trim()) {
                                categories.add(p.category);
                            }

                            if (typeof p.sub_category !== 'undefined' && p.sub_category !== null && p.sub_category.trim()) {
                                subCategories.add(p.sub_category);
                            }

                            if (typeof p.municipality !== 'undefined' && p.municipality.trim()) {
                                municipalities.add(p.municipality);
                            } else {
                                console.warn('invalid object');
                                console.warn(p);
                            }

                            this.categories =  [...categories].sort();
                            this.municipalities  = [...municipalities].sort();
                            this.subCategories  = [...subCategories].sort();
                        });


                        if (this.display === 'map') {
                            this.displayMarkers();
                        }

                        this.amounts = {};

                        for (const batch of this.paginatedResults) {
                            for (const product of batch) {
                                for (const municipality of this.municipalities) {
                                    if (product['municipality'] === municipality) {
                                        if (!this.amounts.hasOwnProperty(municipality)) {
                                            this.amounts[municipality] = 1;
                                        } else {
                                            this.amounts[municipality] += 1;
                                        }
                                    }
                                }
                                for (const category of this.categories) {
                                    if (product['category'] === category) {
                                        if (!this.amounts.hasOwnProperty(category)) {
                                            this.amounts[category] = 1;
                                        } else {
                                            this.amounts[category] += 1;
                                        }
                                    }
                                }
                            }
                        }


                        this.queryParamsHandler();
                    });
                },
                queryParamsHandler() {
                    const length = this.selectedCategories.length +
                                    this.selectedSubCategories.length +
                                   this.selectedMunicipalities.length;

                    let queryParams = `?t=${this.display}&`;
                    let counter     = 0;

                    if (this.search) {
                        queryParams += `s=${this.search}${length ? '&' : ''}`;
                    }
                    for (const category of this.selectedCategories) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `kategori[]=${category}${and}`;
                        counter++;
                    }

                    for (const municipality of this.selectedMunicipalities) {
                        const and = (counter !== length - 1 ? '&' : '');
                        queryParams += `kommune[]=${municipality}${and}`;
                        counter++;
                    }

                    const origin   = window.location.origin;
                    const pathname = window.location.pathname;
                    let url = origin + pathname;
                    if (queryParams !== '?') {
                        url += queryParams;
                    }

                    // console.log(url);
                    history.replaceState({}, null, url);
                },

                // Google-map //
                generateMap() {
                    const options = {
                        zoom             : 9,
                        mapTypeControl   : false,
                        streetViewControl: false,
                        fullscreenControl: false,
                        scrollwheel      : false
                    }
                    this.map    = new google.maps.Map(this.$refs.map, options);
                    this.bounds = new google.maps.LatLngBounds();
                },
                addMarkers() {
                    for (const product of this.products) {
                        if (!product.lat || !product.lng) {
                            continue;
                        }

                        const productCat = product.category;
                        let markerIconName = "undefined";
                        /* TODO, new icons by category */
                        /* if (typeof productCat !== "undefined" && productCat !== null ) {
                            markerIconName = _.snakeCase(product.category);
                            console.log(markerIconName);
                        } */

                        const markerImgUrl = `/resources/img/marker_${markerIconName}.svg`;
                        const markerSize   = new google.maps.Size(18.4, 32.9);
                        const markerIcon   = new google.maps.MarkerImage(
                            markerImgUrl,
                            markerSize
                        );

                        const marker       = new google.maps.Marker({
                            position: new google.maps.LatLng(product.lat, product.lng),
                            map     : this.map,
                            icon    : markerIcon
                        });

                        this.bounds.extend(marker.position);

                        const infoWindow = new google.maps.InfoWindow({
                            content: this.getInfoWindowContent(product)
                        });

                        this.mapData.push({
                            marker      : marker,
                            infoWindow  : infoWindow,
                            categories  : product.category,
                            municipality: product.municipality,
                            pictureUrl  : product.img
                        });
                    }

                    for (const item of this.mapData) {
                        item.marker.addListener('click', () => {
                            if (this.activeInfoWindow) {
                                this.activeInfoWindow.close();
                            }
                            const imgString = '<img class="map-info__image"';
                            if (!item.infoWindow.content.includes(imgString + ' src=')) {
                                const splitContent = item.infoWindow.content.split(imgString);
                                if (splitContent.length === 2) {
                                    const content = splitContent[0] + `${imgString} src="${item.pictureUrl}"` + splitContent[1];
                                    item.infoWindow.setContent(content);
                                }
                            }
                            item.infoWindow.open(this.map, item.marker);
                            this.activeInfoWindow = item.infoWindow;
                        });
                    }

                    this.map.fitBounds(this.bounds);
                },
                displayMarkers() {
                    for (const product of this.mapData) {
                        const categoryMatch     = !this.selectedCategories.length ||
                                                   this.selectedCategories.some(category => product.categories.indexOf(category) >= 0);
                        const municipalityMatch = !this.selectedMunicipalities.length ||
                                                   this.selectedMunicipalities.includes(product.municipality);
                        const showMarker        = (municipalityMatch && categoryMatch) ||
                                                  (!this.selectedCategories.length && !this.selectedMunicipalities.length)
                        product.marker.setVisible(showMarker)
                    }
                },
                getInfoWindowContent(product) {
                    const iconStart = '<img class="product__info-icon" src="/resources/img/icon--';

                    let content = `
                        <div class="map-info" id="content">
                            ${product.img ? '<img class="map-info__image">' : ''}
                            <div class="map-info__content">
                                <div class="map-info__title">${product.title}</div>
                                <div class="map-info__links">
                    `;
                    if (product.phone) {
                        content += `
                            <a class="map-info__link" href="tel:${product.phone}">
                                ${iconStart}01.png" alt="">${product.phone}
                            </a>
                        `;
                    }
                    if (product.email) {
                        content += `
                            <a class="map-info__link" href="mailto:${product.email}">
                                ${iconStart}02.png" alt="">${product.email}
                            </a>
                        `;
                    }
                    if (product.web) {
                        if (!product.web.includes('http')) {
                            product.web = 'http://' + product.web;
                        }
                        content += `
                            <a class="map-info__link" href="${product.web}">
                                ${iconStart}03.png" alt="">Nettside
                            </a>
                        `;
                    }
                    content += `
                                </div>
                                <a class="map-info__redirect" href="${product.url}">
                                    Les mer${product.booking ? ' og bestill' : ''}
                                </a>
                            </div>
                        </div>
                    `;

                    return content;
                }
            },
            computed: {
                paginatedResults() {
                    this.pageIndex = 0;

                    const size = this.productsPerPage;
                    const products = this.filteredProducts(this.products);
                    const paginatedResults = [];

                    for (let i = 0; i < products.length; i += size) {
                        paginatedResults.push(products.slice(i, i + size));
                    }
                    // if (this.display === 'map') {
                    //     this.displayMarkers();
                    // }

                    return paginatedResults;
                },
                amountOfPages() {
                    return this.paginatedResults.length;
                },
                amountOfProducts() {
                    let count = 0;
                    for (const batch of this.paginatedResults) {
                        count += batch.length;
                    }

                    return count;
                }
            },
            watch: {
                display(val) {
                    this.display   = val;
                    this.pageIndex = 0;

                    // setTimeout(() => {
                        // if (this.display === 'map' && this.$refs.map) {
                        //     this.generateMap();
                        //     this.addMarkers();
                        //     this.displayMarkers();
                        // }
                    // });
                }
            }
        });
    },
    reload() {
        this.init();
    },
    change() {
        this.init();
    }
}